import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-learning-banner',
  templateUrl: './learning-banner.component.html',
  styleUrls: ['./learning-banner.component.scss']
})
export class LearningBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
